<autocomplete-list-item (clicked)="triggerEvent()"> {{ item.label }} </autocomplete-list-item>
